

export class ComplaintType {
    
    Id:Number;
    Name: string;
}